import { actionTypes } from './actions';

export const initialState = {
  isAudioLoading: false,
  audioLink: '',
  isPlaying: false,
  playAudioButtonId: '',
  requestPreviewId: '',
};

const dictionaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_LOADING_PLAY_AUDIO_STATUS: {
      const { status } = action;
      return { ...state, isAudioLoading: status };
    }

    case actionTypes.UPDATE_PLAYING_AUDIO_STATUS: {
      const { status } = action;
      return { ...state, isPlaying: status };
    }

    case actionTypes.UPDATE_PLAY_AUDIO_BUTTON_ID: {
      const { id } = action;
      return { ...state, playAudioButtonId: id };
    }

    case actionTypes.UPDATE_PLAY_AUDIO_LINK: {
      const { audioLink } = action;
      return { ...state, audioLink };
    }

    case actionTypes.UPDATE_PLAY_AUDIO_REQUEST_ID: {
      const { requestId } = action;
      return { ...state, requestPreviewId: requestId };
    }

    case actionTypes.RESET_PREVIEW_AUDIO: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default dictionaryReducer;
